/**
  * This component is a custom select
  * menu for the user to select an option
  * from a simple list.
**/
import React, { ReactElement, useEffect, useState } from 'react';
import * as bootstrap from 'bootstrap';
import classNames from 'classnames';

import './DropdownSelect.scss';

interface DropdownButtonProps {
  defaultValue: string | ReactElement,
  label?: string | ReactElement,
  labelClass?: string,
  options: Array<any> | ReactElement,
  className?: string,
  id: string,
  wrapperClass?: string,
  menuClass?: string,
  color: string,
  variant: string,
  autoclose?: string,
  icon?: string,
  fullWidth?: boolean,
  resetText?: boolean,
}

const DropdownSelect = ({
	autoclose,
	defaultValue,
	label,
	labelClass,
	options,
	className,
	id,
	wrapperClass,
	menuClass,
	color,
	variant,
	icon,
	fullWidth,
	resetText,
}: DropdownButtonProps) => {
	const [dropdownElement, setDropdownElement] = useState<bootstrap.Dropdown>();
	const [show, setShow] = useState(false);

	useEffect(() => {
		const dropdown = document.getElementById(id);
		const dropdownTriggerElement = bootstrap.Dropdown.getOrCreateInstance(dropdown as HTMLElement);
		setDropdownElement(dropdownTriggerElement);

		dropdown?.addEventListener('show.bs.dropdown', function () {
			setShow(true);
		});

		dropdown?.addEventListener('hide.bs.dropdown', function () {
			setShow(false);
		});

	}, [id]);

	return (
		<div className={classNames(wrapperClass && wrapperClass, 'dropdown position-relative')}>
			{label && <div className={classNames(labelClass && labelClass)}>{label}</div>}
			<button
				id={id}
				className={classNames(className && className, `cc-btn cc-btn--${variant} cc-btn--${color}`, resetText && 'cc-btn--reset-text')}
				type="button"
				data-bs-toggle="dropdown"
				data-bs-reference="parent"
				data-bs-auto-close={autoclose ? autoclose : true}
				aria-expanded="false"
				onClick={(event: React.MouseEvent) => {
					event.preventDefault();
					dropdownElement?.toggle();
				}}
			>
				{defaultValue}
				<i
					className={classNames(
						icon ? icon : show ? 'dropdown-icon--flip-vertically far fa-times' : 'fas fa-caret-down',
						'dropdown-icon text-secondary ms-2',
					)}
				/>
			</button>
			<ul
				role="menubar"
				id={`${id}-options`}
				className={classNames(menuClass && menuClass, fullWidth ? 'w-100' : '', 'w-100 dropdown-menu shadow border-0')}
				aria-labelledby={id}
			>
				{options}
			</ul>
		</div>
	);
};

export default DropdownSelect;
